export default __webpack_public_path__ + "static/media/email.d0e55e3a.svg";